module.exports = __webpack_public_path__ + "img/user-price.eec0bfa1.png";